export default [
  {
    path: "/planos",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "planos_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "planos", to: "planos_list" }],
          permission: "plano:view",
          title: "Planos",
        },
      },
      {
        name: "planos_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "planos", to: "planos_list" }],
          permission: "plano:create",
          title: "Planos - Cadastro",
        },
      },
      {
        name: "planos_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "planos", to: "planos_list" }],
          permission: "plano:edit",
          title: "Planos - Edição",
        },
      },
    ],
  },
];
